
import { AMMUNITION_STOCK_EVENT_METADATA } from './ammunition-stock-event.metadata';
import { AmmunitionStockEventBase } from './ammunition-stock-event.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface AmmunitionStockEvent extends AmmunitionStockEventBase {
}

export interface AmmunitionStockEventTransient { }

export class AmmunitionStockEvent extends CrudEntity<AmmunitionStockEvent, number, AmmunitionStockEventTransient> implements AmmunitionStockEventTransient {
  constructor(source?: Partial<AmmunitionStockEvent>, options?: CrudEntityConstructionOptions<AmmunitionStockEvent, number, AmmunitionStockEventTransient>) {
    super(AMMUNITION_STOCK_EVENT_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





